module.exports = __webpack_public_path__ + "img/nature.0cf9dfa4.svg";